module.exports = __webpack_public_path__ + "static/media/opensans-italic-webfont.159f88f7.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-italic-webfont.woff2
// module id = 1019
// module chunks = 0